import { Variable, variablesToFieldsInfo } from '@microservices/wiskey-react-components'

import { VariableValue } from '@components/Variables/types'

import { AutocompleteOption, ObjectFieldDTO } from '@types'

export const getObjectXCellScriptHint = (data: {
  objectX?: AutocompleteOption
  objectY?: AutocompleteOption
  variables: VariableValue[]
  objectYFields: ObjectFieldDTO[]
  objectXFields: ObjectFieldDTO[]
}) => {
  const { objectXFields, objectYFields, variables } = data

  const variablesInfo: Variable[] = [
    {
      name: 'cellItem',
      type: !objectXFields?.length
        ? 'any'
        : objectXFields.map(field => {
            return {
              name: field.name,
              type: field.valueType,
              description: field.desc,
            } as Variable
          }),
    },
    {
      name: 'value',
      isArray: true,
      type: !objectXFields?.length
        ? 'any'
        : objectXFields.map(field => {
            return {
              name: field.name,
              type: field.valueType,
              description: field.desc,
            } as Variable
          }),
    },
    { name: 'startDate', type: 'string' },
    { name: 'valueKey', type: 'string', description: 'Column key' },
    { name: 'endDate', type: 'string' },
    { name: 'moment', type: 'any' },
    { name: 'cellItemIndex', type: 'number' },
    { name: 'cellWidth', type: 'number' },
    { name: 'cellHeight', type: 'number' },
  ]

  return {
    variables: [
      {
        name: 'srcObj',
        type: [...variablesInfo, { name: 'row', type: 'any' }],
      },
    ],
    fieldsInfo: variablesToFieldsInfo(
      [
        ...variablesInfo,
        {
          name: 'row',
          type: [
            {
              name: 'yElement',
              type: !objectYFields?.length
                ? 'any'
                : objectYFields.map(field => {
                    return {
                      name: field.name,
                      type: field.valueType,
                      description: field.desc,
                    } as Variable
                  }),
            },
            { name: 'id', type: 'string' },
            { name: 'groupId', type: 'string' },
            {
              name: 'variables',
              type: variables.map(variable => {
                return {
                  name: variable.internalId,
                  type: [
                    { name: 'defaultValue', type: 'any', description: '' },
                    { name: 'valueType', type: 'string', description: '' },
                    { name: 'variableType', type: 'string', description: '' },
                    { name: 'entityType', type: 'string', description: '' },
                  ],
                } as Variable
              }),
            },
          ],
        },
      ],
      'srcObj'
    ),
    examples: [
      {
        title: 'Roster Duty Shift',
        code:
          ' <div\n' +
          '          style={{\n' +
          '            backgroundColor:\n' +
          "              srcObj.cellItem.extra === true ? '#f59c1a' : srcObj.cellItem.shift_type_plan === 1 ? '#001181' : ['#C9E7DD', '#3B0075', '#009E14', '#9E002F'][srcObj.cellItemIndex], // Цвета отображаемых смен\n" +
          "            color: 'white',\n" +
          "            height: '100%',\n" +
          "            display: 'flex',\n" +
          "            flexDirection: 'column',\n" +
          "            alignItems: 'center',\n" +
          "            justifyContent: 'center',\n" +
          "            position: 'relative',\n" +
          '            fontSize: srcObj.value.length > 2 ? (srcObj.value.length > 3 ? 8 : 12) : 14,\n' +
          '          }}\n' +
          '        >\n' +
          "        {srcObj.cellItem.comment && srcObj.cellHeight > 60 && <div style={{position: 'absolute', color: 'red', right: 4, top: 2}}>\n" +
          '          *\n' +
          '        </div>}\n' +
          '          {/*\n' +
          '              Строка отображаемая в ячейке, поля берутся из объекта ObjectX\n' +
          '              Проверка типа смены\n' +
          '            */}\n' +
          "          {srcObj.cellItem.duty_type_plan_ref === 'А' || !srcObj.cellItem.duty_type_plan_ref\n" +
          "            ? `${srcObj.moment(srcObj.cellItem.duty_start).format(srcObj.cellWidth > 90 ? 'HH:mm' : 'HH')}-${srcObj\n" +
          '              .moment(srcObj.cellItem.duty_end)\n' +
          "              .format(srcObj.cellWidth > 90 ? 'HH:mm' : 'HH')}`\n" +
          '            : srcObj.cellItem.duty_type_plan_ref}\n' +
          '    {srcObj.cellHeight > 60 ? <div>{`${srcObj.moment(srcObj.cellItem.duty_end)\n' +
          "  .diff(srcObj.moment(srcObj.cellItem.duty_start), 'hours')} ч.`}</div> : null}\n" +
          '</div>\n',
      },
      {
        title: 'Start date (Roster Person Qualification)',
        code:
          '<div style={{\n' +
          "  width: '100%',\n" +
          "  height: '100%',\n" +
          "  color: 'white',\n" +
          "  backgroundColor: '#5968bfff',\n" +
          "  justifyContent: 'center',\n" +
          "  alignItems: 'center',\n" +
          "  display: 'flex',\n" +
          '}}>\n' +
          "Дата начала:{srcObj.moment(srcObj.cellItem.date_start).format('DD.MM.YYYY')}\n" +
          '</div>',
      },
      {
        title: 'Qualification presence (Roster Person Qualification)',
        code:
          '<div style={{\n' +
          "  width: '100%',\n" +
          "  height: '100%',\n" +
          "  color: 'white',\n" +
          "  backgroundColor: '#5968bfff',\n" +
          "  justifyContent: 'center',\n" +
          "  alignItems: 'center',\n" +
          "  display: 'flex',\n" +
          '  fontSize: 16,\n' +
          '}}>\n' +
          '✓\n' +
          '</div>',
      },
    ],
  }
}
